import { Button, Grid, TextField } from '@mui/material';
import React from 'react';
import SubCard from 'ui-component/cards/SubCard';
// import Box from '@mui/material/Box';
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';

const DsPaymentFilters = (props) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <SubCard title="Ds Payment List">
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item lg={6} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={4} xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    value={props.filter?.ds_name}
                    id="outlined-basic"
                    label="DS Name"
                    onChange={(e) => props.handleChange('ds_name', e.target.value)}
                    variant="outlined"
                  />
                </Grid>
                <Grid item lg={4} xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    id="outlined-basic"
                    value={props.filter?.ds_mobile_number}
                    onChange={(e) => props.handleChange('ds_mobile_number', e.target.value)}
                    label="DS Mobile No"
                    variant="outlined"
                  />
                </Grid>
                {/* <Grid item lg={4} xs={12}>
                                    <Box sx={{ minWidth: 120 }}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={props.filter?.status}
                                                label="Status"
                                                onChange={(e) => props.handleChange("status", e.target.value)}
                                            >
                                                <MenuItem value={"pending"}>Pending</MenuItem>
                                                <MenuItem value={"approved"}>Approved</MenuItem>
                                                <MenuItem value={"rejected"}>Rejected</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid> */}
              </Grid>
            </Grid>
            <Grid item lg={2} xs={12}>
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <Button fullWidth variant="outlined" color="secondary" size="small" onClick={props.handleClear}>
                    clear
                  </Button>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Button fullWidth variant="contained" color="secondary" size="small" onClick={props.handleSearch}>
                    Search
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </SubCard>
      </Grid>
    </Grid>
  );
};

export default DsPaymentFilters;
